module.exports = __webpack_public_path__ + "img/icon-ok.f260b612.jpg";